import { GabbiLogo } from './Gabbi.logo'

const TopBar = () => {
  return (
    <div className='py-12'>
      <GabbiLogo />
    </div>
  )
}

export default TopBar
